import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="nav">
        <div className="nav-brand">
          <Link to="/" className="nav-brand-link" onClick={closeMobileMenu}>
            Khiem Vinh Tran
          </Link>
        </div>
        
        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <i className="fas fa-bars"></i>
        </button>

        <ul className={`nav-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
          <li>
            <Link 
              to="/publications" 
              className={`nav-link ${location.pathname === '/publications' ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Publications
            </Link>
          </li>
          <li>
            <Link 
              to="/supervision" 
              className={`nav-link ${location.pathname === '/supervision' ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Supervision
            </Link>
          </li>
          <li>
            <Link 
              to="/teaching" 
              className={`nav-link ${location.pathname === '/teaching' ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Teaching
            </Link>
          </li>
          <li>
            <Link 
              to="/cv" 
              className={`nav-link ${location.pathname === '/cv' ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              CV
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header; 